import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { verifyRoute } from '@app/finxone-web-frontend/app/app.module';
import { ProfileStateModel } from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import * as Sentry from '@sentry/angular';
import { Observable, map, take } from 'rxjs';
import { GetProfile } from '../../actions/user-profile.action';
import { ProfileState } from '../../state/user-profile.state';
import { isAuthenticatedRoute } from '../../utils/auth-checks.utils';
import { getReturnUrlForCurrentLocation } from '../../utils/utils';
import { CardManagementService } from '../card-management-service/card-management-service';
import { ConfigService } from '../config-service/config-service.service';
import { DeviceTypeService } from '../device-type/device-type.service';
import { ProjectSettingsState } from '../../state/project-settings.state';

@Injectable({
  providedIn: 'root',
})
export class InitializationService {
  @Select(ProfileState.getProfile)
  private profileStateData!: Observable<ProfileStateModel>;
  public activeRole: string;

  constructor(
    private store: Store,
    private router: Router,
    private configService: ConfigService,
    private cardService: CardManagementService,
    public deviceTypeService: DeviceTypeService,
    private route: ActivatedRoute,
  ) {}

  public initializeApp(token: string) {
    //check if data is already stored in state else it will dispatch get profile
    if (isAuthenticatedRoute(window.location.pathname)) {
      this.store.dispatch(new GetProfile());
      this.setRoleFromProfileState(token);
    } else {
      this.configService.setRoleInfo(token);
    }
  }
  setRoleFromProfileState(token: string) {
    // when the app boots directly on an authenticated deep link (e.g. the AISP
    // return to /nominated-account-status), the current location IS the return
    // target - without this, verifyRoute navigates away before the route activates
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') ?? getReturnUrlForCurrentLocation();

    const settings = this.store.selectSnapshot(ProjectSettingsState.getProjectSettings);

    const kycStatusRoutingConfig = settings?.projectConfig?.kycStatusRoutingConfig ?? null;
    this.profileStateData
      .pipe(
        take(2),
        map((profileData: ProfileStateModel) => {
          // on /post-auth the PostAuthComponent owns post-login routing - running
          // verifyRoute here as well races it with a second navigation
          if (profileData?.id && !window.location.pathname.startsWith('/post-auth')) {
            const redirectForApplePayEnabled =
              this.configService.config.features?.redirectForApplePayEnabled ?? true;
            const profileDataForVerifyRoute = {
              ...profileData,
              marketingPreferences: {
                email: false,
                sms: false,
                push: false,
                mail: false,
              },
            };

            verifyRoute(
              this.router,
              profileDataForVerifyRoute,
              false,
              this.cardService,
              this.store,
              undefined,
              redirectForApplePayEnabled,
              returnUrl,
              this.deviceTypeService,
              kycStatusRoutingConfig,
              this.route,
            );
          }
          if (profileData.activeRole) {
            this.activeRole = profileData.activeRole;
            this.configService.setActiveRole(this.activeRole);
            if (profileData.activeOrganisationId) {
              // this.store.dispatch(
              //   new GetOrganisation(profileData.activeOrganisationId),
              // );
            }

            if (profileData.id && profileData.email) {
              Sentry.setUser({
                id: profileData.id,
                email: profileData.email,
              });
            }
          } else {
            // Atempt to try set the role
            this.configService.setRoleInfo(token);
          }
        }),
      )
      .subscribe();
  }
}
